import { createReducer } from "redux-create-reducer";
import { RPC_ACTIONS } from "./rpcActions";
import { MISC_VALIDATION_ACTIONS } from "../misc/miscActions";
const INITIAL_STATE = {
    isLoading: false,
    error: null,
    fieldErrors: []
};
export default createReducer(INITIAL_STATE, {
    [RPC_ACTIONS.REFERRAL_STARTED](state, _action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            fieldErrors: []
        };
    },
    [RPC_ACTIONS.REFERRAL_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [RPC_ACTIONS.REFERRAL_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            error: new Error("Please correct any errors and try again."),
            fieldErrors: action.payload
        };
    },
    [RPC_ACTIONS.REFERRAL_SUCCEEDED_TRUE](state, _action) {
        return {
            ...state,
            isLoading: false
        };
    },
    /* --- Reset Status Messages --- */
    [MISC_VALIDATION_ACTIONS.RESET_MESSAGES](state, _action) {
        return {
            ...state,
            isLoading: false,
            error: null,
            fieldErrors: []
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/rpc/rpcReducer.ts